import { Controller } from "react-hook-form";
import { useState } from "react";
import {
  Autocomplete,
  FormHelperText,
  TextField,
} from "@mui/material";

import { ComponentTypes } from "../FormTypes";
import { ListOptions } from "../../models/Master";
import { autoCompleteWrapper, TextFieldStyle } from "../styles/styles";

export const FormSelectAutoComplete = ({
  control,
  helper,
  name,
  list,
  style,
  onChangeHandler,
  handleInputChange,
  placeholder,
  disabled,
  clearErrors,
  isMultiLine,
  required = false,
}: ComponentTypes) => {
  const [open, setOpen] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...(helper || {}),
        validate: (value: any) => {
          const helperValidate = (helper as any)?.validate;
          if (typeof helperValidate === "function") {
            const res = helperValidate(value);
            if (res !== true) return res;
          } else if (typeof helper?.validate === "object" && helper.validate !== null) {
            const validators = helper?.validate;
            for (const k of Object.keys(validators)) {
              const r = validators[k](value);
              if (r !== true) return r;
            }
          }
          if (!required) return true;
          const found = Array.isArray(list) && list.some((o: any) => o.value === value);
          return found || "Agency is required ";
        },
      }}
      render={({ field, fieldState: { error } }) => (
        <>
          <Autocomplete
            {...field}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            freeSolo={false}
            id={`${name}-list`}
            disableClearable={false}
            disabled={disabled}
            options={list}
            onBlur={() => {
              field.onBlur();
              setOpen(false);
            }}
            value={
              (list && list.find((option) => option.value === field.value)) ||
              null
            }
            getOptionLabel={(option: ListOptions | string) =>
              typeof option === "string" ? option : `${option.name}\n${option.address}`
            }
            onChange={(_e: any, value: any) => {
              field.onChange(value ? value.value : null);
              if (clearErrors) clearErrors(name);
              if (onChangeHandler) onChangeHandler(_e, value?.value);
            }}
            onInputChange={handleInputChange}
            renderOption={(props, option: ListOptions) => (
              <li {...props}>
          <div>
            <div>{option.name}</div>
            <div>{option.address}</div>
          </div>
              </li>
            )}
            renderInput={(params) => (
              <TextField
          {...params}
          variant="standard"
          {...(isMultiLine && { multiline: true, rows: field.value > 0 ? 2 : 1 })}
          InputProps={{
            ...params.InputProps,
            type: "search",
          }}
          placeholder={placeholder}
          sx={
            disabled
              ? TextFieldStyle(true)
              : {
            ...style,
            ...autoCompleteWrapper,
                }
          }
              />
            )}
          />
          {error?.message && (
            <FormHelperText error>{error.message}</FormHelperText>
          )}
        </>
      )}
    />
  );
};
